import React from 'react';
import { observer } from 'mobx-react';
import AddDeviceToGroupComponent from './Add-device-to-group.component';
import useEditGroup from './useAddDeviceToGroup';
import { ICloseEvent } from '@core/interfaces/ICloseEvent';

const Container: React.FC<ICloseEvent> = ({ onClose }: ICloseEvent) => {
    const { state, store, lang, handlers, devices } = useEditGroup(onClose);

    return (
        <>
            <AddDeviceToGroupComponent
                devices={devices.deviceList}
                lang={lang.lang}
                loading={store.changeGroupDescriptionLoading || store.loading}
                imeiDevices={state.imeiDevices}
                groupName={state.groupName}
                groupNameError={state.groupNameError}
                serverError={store.serverError}
                onGroupNameChange={handlers.handleGroupNameChange}
                onSaveClick={handlers.handleSaveClick}
                onInputClick={handlers.handleInputClick}
                onKeyDown={handlers.handleKeyDown}
                onBtnKeyDown={handlers.handleBtnKeyDown}
                onClose={onClose}
                onCheckedDevice={handlers.handleCheckedDevice}
            />
        </>
    );
};

const AddDeviceToGroupContainer = observer(Container);

export default AddDeviceToGroupContainer;
